import {
  Directive, ElementRef, Input, Output, EventEmitter, Renderer2,
  ViewContainerRef, ComponentFactoryResolver, OnInit
} from '@angular/core';
@Directive({
    selector: '[appFrontFactory]',
    standalone: false
})
export class FrontFactoryDirective implements OnInit {
  @Input() comp: string;
  @Input() foldData: any;
  @Input() userData: any;
  @Output() dateEmitter = new EventEmitter();
  dataKey = '_factories';
  constructor(
    private elem: ElementRef,
    private renderer: Renderer2,
    private vcRef: ViewContainerRef,
    public resolver: ComponentFactoryResolver) {
  }
  ngOnInit() {
    const factories = Array.from(this.resolver[this.dataKey].keys());
    const factoryClass: any = factories.find((x: any) => x.name === this.comp);
    const factory: any = this.resolver.resolveComponentFactory(factoryClass);
    const compRef = this.vcRef.createComponent(factory);
    if (this.foldData) {
      (compRef.instance as any).foldData = JSON.parse(this.foldData);
    }
    if (this.userData) {
      (compRef.instance as any).userData = this.userData;
    }
  }

}
